// extracted by mini-css-extract-plugin
export default {"root":"OneToManySubscription_root__ToEBC","footer":"OneToManySubscription_footer__l6Xq0","logo":"OneToManySubscription_logo__YJach"};